// composables/useFunctions.js

export function useFunctions() {
  const { locale } = useI18n();
  const token = useCookie("XSRF-TOKEN");
  const { public: publicConfig } = useRuntimeConfig();

  function getLocale() {
    return locale.value;
  }

  function getAuthHeaders() {
    let headers = {
      accept: "application/json",
      referer: publicConfig.appUrl,
    };

    if (token.value) {
      headers["X-XSRF-TOKEN"] = token.value as string;
    }

    if (process.server) {
      headers = {
        ...headers,
        ...useRequestHeaders(["cookie"]),
      };
    }
    return headers;
  }

  const handleAvatar = (avatar: string, url: string): string => {
    if (avatar?.includes("https://api.boostingmarket.com")) {
      return avatar;
    } else if (avatar.includes("http://localhost:8000")) {
      return avatar;
    } else if (avatar.includes("http://127.0.0.1:8000")) {
      return avatar;
    } else if (avatar.includes(url)) {
      return avatar;
    }
    return `${url}${avatar}`;
  };

  return {
    getLocale,
    getAuthHeaders,
    handleAvatar
  };
}
